__webpack_require__.p = "/invite/";